/*
 * One place to ask whether the visitor has asked their system to reduce
 * motion. Read at call time rather than cached at load, so the answer is
 * still right if the setting changes between page loads.
 *
 * The CSS side lives in src/css/base.css and src/css/components.css.
 */
const QUERY = '(prefers-reduced-motion: reduce)'

export const prefersReducedMotion = () => window.matchMedia(QUERY).matches
